import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as LIKE_TYPE} from '../creators/like';
import {TYPES as MEDIA_TYPE} from '../creators/mediaviewer.media';
// import {TYPES as MEDIAS_TYPE} from '../creators/medias';

export function* createSuccess(action) {
    try {
        // console.log(action.payload);
        yield put({type: "LIKES_ADD", data : action.payload});
        if(action.payload.parentKind === "gallery" || action.payload.parentKind === "video"){
            yield put({type: MEDIA_TYPE.ADD_LIKE, data : action.payload});
            // yield put({type: MEDIAS_TYPE.ADD_LIKE, data : action.payload});
        }
    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "LIKES_DELETE", data : action.payload});
        if(action.payload.parentKind === "gallery" || action.payload.parentKind === "video"){
            yield put({type: MEDIA_TYPE.DELETE_LIKE, data : action.payload});
            // yield put({type: MEDIAS_TYPE.DELETE_LIKE, data : action.payload});
        }
    } catch (error) {

    }
}

export function* watchLike() {
    yield takeEvery(LIKE_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(LIKE_TYPE.DELETE_SUCCESS, deleteSuccess);
}

export default watchLike;

